/**
 * Scroll event.
 * @link https://github.com/DjonnyX/rcx-virtual-list/tree/main/src/lib/src/utils/scrollEvent.ts
 * @author Evgenii Grebennikov
 * @email djonnyx@gmail.com
 */
export class ScrollEvent {
    get direction() { return this._direction; }
    get scrollSize() { return this._scrollSize; }
    get scrollWeight() { return this._scrollWeight; }
    get isVertical() { return this._isVertical; }
    get listSize() { return this._listSize; }
    get size() { return this._size; }
    get isStart() { return this._isStart; }
    get isEnd() { return this._isEnd; }
    get delta() { return this._delta; }
    get scrollDelta() { return this._scrollDelta; }
    constructor(params) {
        this._direction = 1;
        this._scrollSize = 0;
        this._scrollWeight = 0;
        this._isVertical = true;
        this._listSize = 0;
        this._size = 0;
        this._isStart = true;
        this._isEnd = false;
        this._delta = 0;
        this._scrollDelta = 0;
        const { direction, isVertical, container, list, delta, scrollDelta } = params;
        this._direction = direction;
        this._isVertical = isVertical;
        this._scrollSize = isVertical ? container.scrollTop : container.scrollLeft;
        this._scrollWeight = isVertical ? container.scrollHeight : container.scrollWidth;
        this._listSize = isVertical ? list.offsetHeight : list.offsetWidth;
        this._size = isVertical ? container.offsetHeight : container.offsetWidth;
        this._isEnd = (this._scrollSize + this._size) === this._scrollWeight;
        this._delta = delta;
        this._scrollDelta = scrollDelta;
        this._isStart = this._scrollSize === 0;
    }
}
